import { render } from "./CardVideoOrImg.vue?vue&type=template&id=091115c4"
import script from "./CardVideoOrImg.vue?vue&type=script&lang=js"
export * from "./CardVideoOrImg.vue?vue&type=script&lang=js"

import "./CardVideoOrImg.vue?vue&type=style&index=0&id=091115c4&labg=css&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__